import React, { Component } from 'react';
import styles from './Tooltip.scss';
import classnames from 'classnames';

export class Tooltip extends Component{
    constructor(props) {
        super(props);
        this.state = {
            active : false
        };
    }
    
    toggleTip(){
        this.setState({
            active : !this.state.active
        });
    }

    render(){
        const { direction, children, content} = this.props;
        return (
            <div
                className={styles.tooltip_wrapper}
                onClick={() => this.toggleTip()}
                data-cy="Tooltip"
            >
                {children}
                {this.state.active && (
                    <div className={
                        classnames(
                            styles.tooltip_tip,
                            {
                                [styles[direction]]: direction,
                                [styles.right]: !direction,
                            },
                        )
                    } data-cy="Tooltip-div">
                        {content}
                    </div>
                )}
            </div>
        );
    }
}

export default Tooltip;
